'use strict';

var eventClose = function(e) {
    $(this)
        .data({
            listId: '',
            listItemIds: ''
        });
};

var eventClickDelete = function(e) {
    e.preventDefault();
    var $modal = $('#wishlistEnhancementsModalDeleteProducts');
    $.spinner().start();
    $.ajax({
        url: $modal.data().url,
        method: 'POST',
        dataType: 'html',
        data: {
            listId: $modal.data().listId,
            listItemIds: JSON.stringify($modal.data().listItemIds)
        },
        success: function(html) {
            $('.product-list-enhancements-global-error-display').trigger('clear');
            $('.product-list-enhancements-overlay-detail-selected').trigger('close');
            $('.product-list-enhancements-detail').trigger('updateProducts', $(html).find('.product-list-enhancements-detail-products'));
            $modal.modal('hide');
        },
        error: function() {
            $modal.modal('hide');
            $('.product-list-enhancements-global-error-display').trigger('error');
            $.spinner().stop();
        }
    });
}

var addEventListeners = function() {
    $('#wishlistEnhancementsModalDeleteProducts')
        .on('click', '.product-list-enhancements-modal-delete-products-btn', eventClickDelete)
        .on('hidden.bs.modal', eventClose);
};

var removeEventListeners = function() {
    $('#wishlistEnhancementsModalDeleteProducts')
        .off('click', '.product-list-enhancements-modal-delete-products-btn', eventClickDelete)
        .off('hidden.bs.modal', eventClose);
};

var init = function() {
    addEventListeners();
}

var destroy = function() {
    removeEventListeners();
}

module.exports = {
    init,
    destroy
}
